export default validateInput = input => {
  let valid = true;
  if (input && input.hasAttribute('data-required') && !input.value) {
    input.placeholder = input.getAttribute('data-required');
    valid = false;
  } else if (input.hasAttribute('data-multi')) {
    return valid;
  } else if (input.hasAttribute('data-list')) {
    const allowedValues = input.getAttribute('data-list').split(',');
    if (!allowedValues.includes(input.value)) {
      input.value = '';
      input.placeholder = input.getAttribute('data-invalid');
      valid = false;
    }
  }

  return valid;
}